<template>
  <div class="container">
    <div class="main">
      <div class="left">
        <div class="title">解决方案</div>
        <div class="text">
          智签科技为化解金融纠纷，准备了完整的解决方案，能够覆盖任何贷前、贷后场景。<br />
          为您的在线金融业务提供高效、合规、可靠的解决方案，实现全方位的护航。
        </div>
      </div>
      <!-- <div class="right">
        <div class="right_box" @click="goBlockchainPlan">
          <div class="title">区块链存证</div>
          <div class="info">
            运用区块链和互联网技术实现对赋强公证业务的在线办理，极大方便债权人和债务人的金融公证业务办理，同时可有效防范金融违约风险，提升社会诉源治理水平，突出公证在防范和化解社会矛盾风险、推进国家诚信建设、提升社会治理能力现代化水平方面作用。
          </div>
          <div class="sustain">
            支持业务
            <div class="sustain_item">业务1</div>
            <div class="sustain_item">业务1</div>
            <div class="sustain_item">业务1</div>
          </div>
        </div>
        <div class="right_box" @click="goFqPlan">
          <div class="title">金融赋强公证</div>
          <div class="info">
            运用区块链和互联网技术实现对赋强公证业务的在线办理，极大方便债权人和债务人的金融公证业务办理，同时可有效防范金融违约风险，提升社会诉源治理水平，突出公证在防范和化解社会矛盾风险、推进国家诚信建设、提升社会治理能力现代化水平方面作用。
          </div>
          <div class="sustain">
            支持业务
            <div class="sustain_item">业务1</div>
            <div class="sustain_item">业务1</div>
            <div class="sustain_item">业务1</div>
          </div>
        </div>
        <div class="right_box" @click="goLitigation">
          <div class="title">诉调一体化</div>
          <div class="info">
            金融案件诉调赋一体化解决方案，将金融、科技与法律充分融合于一体，运用区块链、电子签名、远程音视频等多重技术，实现金融机构、调解机构、公证机关、人民法院无缝实时对接，深化诉源治理，形成从前端调解到末端执行的全链条多元化解机制。
          </div>
          <div class="sustain">
            支持业务
            <div class="sustain_item">业务1</div>
            <div class="sustain_item">业务1</div>
            <div class="sustain_item">业务1</div>
          </div>
        </div>
      </div> -->
      <div class="right">
        <div class="right_box" @click="goBlockchainPlan">
          <div class="title">区块链存证</div>
          <div class="context">
            <div class="info">
              基于LegalXChain司法联盟链的存证服务，固化的证据、关键存证操作均能同步上链，能在法院、公证机构、司法鉴定机构、金融机构等多机构之间实现跨链采信。
            </div>
            <div class="tag">
              <div>
                <label>试用场景：</label>
                <span>交易存证</span>
                <span>记录存证</span>
                <span>内容存证</span>
              </div>
              <!-- <div class="icon" @click="goTry">
                申请试用 <i class="el-icon-arrow-right"></i>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right_box" @click="goFqPlan">
          <div class="title">金融赋强公证</div>
          <div class="context">
            <div class="info">
              运用区块链和互联网技术实现赋强公证业务的在线办理及出证，办理全程同步上链，可以有效强化履约意识，防范金融违约风险。
            </div>
            <div class="tag">
              <div>
                <label>支持业务：</label>
                <span>贷前赋强公证</span>
                <span>贷后赋强公证</span>
              </div>
              <!-- <div class="icon" @click="goTry">
                申请试用 <i class="el-icon-arrow-right"></i>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right_box" @click="goLitigation">
          <div class="title">诉调一体化</div>
          <div class="context">
            <div class="info">
              以多元化、多维度的方式将诉前调解、调解赋强、民事诉讼流程融于一体，实现金融机构、调解机构、公证机构、人民法院的无缝实时对接，深化诉源治理。
            </div>
            <div class="tag">
              <div>
                <label>支持业务：</label>
                <span>诉前调解</span>
                <span>赋强公证</span>
                <span>司法确认</span>
                <span>线上立案</span>
              </div>
              <!-- <div class="icon" @click="goTry">
                申请试用 <i class="el-icon-arrow-right"></i>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  created() {},

  methods: {
    goLitigation() {
      this.$emit("close");
      this.$router.push("/programme/litigation");
    },
    goBlockchainPlan() {
      this.$emit("close");
      this.$router.push("/programme/blockchainPlan");
    },
    goFqPlan() {
      this.$emit("close");
      this.$router.push("/programme/fqPlan");
    },
    goTry() {
      this.$emit("close");
      this.$router.push("/try");
    },
  },
};
</script>

<style scoped lang='scss'>
.container {
  // background: url(~@/assets/image/header/product_menu1.png);
  // background-repeat: no-repeat;
  background-color: #f4f5f7;
  // background-size: 100% 100%;
  height: 540px;
  .main {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    .left {
      width: 270px;
      // flex: 1;
      // padding-left: 15px;
      position: relative;

      .title {
        margin: 40px 0 24px;
        color: #000000;
        position: relative;
        z-index: 999;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      .text {
        z-index: 999;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        position: relative;
        color: #808080;
        line-height: 20px;
        width: 236px;
        height: 80px;
      }
    }
    .left:before {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 50vw;
      z-index: 0;
      height: 100%;
      background: #fff url(~@/assets/image/header/left.png) right bottom
        no-repeat;
      background-size: 650px auto;
    }
    .right {
      // background-color: #fff;
      width: 930px;
      height: 100%;
      padding: 34px 0 50px 40px;
      .right_box {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        display: flex;
        margin-bottom: 53px;
        align-items: center;
        cursor: pointer;
        .title {
          width: 140px;
          text-align: center;
          font-size: 14px;
          color: #37393b;
          margin-right: 10px;
        }
        .context {
          flex: 1;
          font-size: 12px;
          color: #656565;
          .info {
            margin-bottom: 13px;
          }
          .tag {
            display: flex;
            justify-content: space-between;
            label {
              color: #37393b;
              margin-right: 6px;
            }
            span {
              display: inline-block;
              height: 22px;
              border: 1px solid #7E7E7E;
              padding: 2px 18px;
              margin-right: 28px;
              color: #7E7E7E;
            }
            .icon {
              color: $main_color;
              cursor: pointer;
            }
          }
        }
      }
      .right_box:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
